import styled, { keyframes } from "styled-components";
import { sizeHandler } from "../utils/IconUtil";
import { Classes } from "./common";
import type { IconSize } from "../utils/IconUtil";

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

const SvgContainer = styled.svg<SpinnerProp>`
  animation: ${rotate} 2s linear infinite;
  width: ${(props) => sizeHandler(props.size, props.theme)}px;
  height: ${(props) => sizeHandler(props.size, props.theme)}px;
`;

const SvgCircle = styled.circle`
  stroke: ${(props) => props.theme.legacy.colors.spinner};
  stroke-linecap: round;
  animation: ${dash} 1.5s ease-in-out infinite;
  stroke-width: ${(props) => props.theme.legacy.spaces[1]}px;
`;

type SpinnerProp = {
  size?: IconSize;
};

Spinner.defaultProp = {
  size: "small",
};

export default function Spinner(props: SpinnerProp) {
  return (
    <SvgContainer
      viewBox="0 0 50 50"
      className={Classes.SPINNER}
      size={props.size}
    >
      <SvgCircle cx="25" cy="25" r="20" fill="none"></SvgCircle>
    </SvgContainer>
  );
}
